var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"intro",class:("intro--" + _vm.logo + " " + _vm.activeClass),attrs:{"data-cy":"intro"}},[_c('div',{staticClass:"intro__ripple"}),_c('div',{staticClass:"intro__logo"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }